import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { AuthenticationService } from '@authentication';
import { BreakpointService } from '../../shared/services/breakpoint/breakpoint.service';

/**
 *Layout del modulo de autenticacion
 *
 * @export
 * @class AuthLayout
 * @implements {OnInit}
 */
@Component({
  standalone: false,
  selector: 'migo-apps-auth',
  templateUrl: './auth.layout.html',
  styleUrls: ['./auth.layout.scss'],
})
export class AuthLayout implements OnInit {
  /**
   *
   */
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    public bp: BreakpointService
  ) { }

  iframeUrl = '';
  ngOnInit(): void {
    this.iframeUrl = `${environment.betaURL}/auth/login?isRedirect=true`;
    window.addEventListener('message', this.receiveMessage, false);
  }

  receiveMessage = (event: MessageEvent) => {
    if (event.origin !== environment.betaURL) {
      console.warn('Mensaje recibido de origen no permitido:', event.origin);
      return;
    }

    const { type, token } = event.data;

    if (type === 'AUTH_SUCCESS') {
      this.authenticationService.setSessionPublic(token);
      this.router.navigate(['dashboard'], {
        queryParams: { welcome: true },
      });
    }
  };
}
